import { createSlice } from '@reduxjs/toolkit';

const namesPageRu = {
  schedule: ' к расписанию',
  subject: ' к предметам',
  homework: 'к домашним работам',
  materials: 'к материалам',
  home: 'к домашней странице',
  createHomework: 'к созданию домашней работів',
};

const namesPageUa = {
  schedule: 'до розкладу',
  subject: 'до предметів',
  homework: 'до домашніх робіт',
  materials: 'до матеріалів',
  home: 'до домашньої сторінки',
  createHomework: 'до створення домашньої роботи',
};

const prevPageArray = JSON.parse(sessionStorage.getItem('history'))
  ? JSON.parse(sessionStorage.getItem('history')).prevPageArray
  : [];
// const prevPageArray = [];

let langNames = '';
let currentNameLang = '';

const backHistorySlice = createSlice({
  name: 'historyPage',
  initialState: {
    pageName: null,
    count: JSON.parse(sessionStorage.getItem('history')) ? JSON.parse(sessionStorage.getItem('history')).count : 0,
    // count: 0,
    corectyNamePage: '',
    langName: '',
  },
  reducers: {
    setNamePage(state, action) {
      state.pageName = action.payload;
      prevPageArray.push(String(action.payload));
      currentNameLang = prevPageArray[prevPageArray.length - 1];
    },
    increment: state => {
      state.count += 1;

      if (prevPageArray.length > 1) {
        switch (langNames) {
          case 'ua':
            state.corectyNamePage = namesPageUa[prevPageArray[state.count - 2]];
            break;
          case 'ru':
            state.corectyNamePage = namesPageRu[prevPageArray[state.count - 2]];
            break;
        }
      }
    },
    decrement: state => {
      if (state.count > 1) {
        state.count -= 2;
      }
    },

    cleanCount: state => {
      state.count = 0;
    },
    setActiveLangSl: (state, action) => {
      state.langName = action.payload;
      langNames = action.payload;

      switch (langNames) {
        case 'ua':
          state.corectyNamePage = namesPageUa[prevPageArray[prevPageArray.length - 2]];
          break;
        case 'ru':
          state.corectyNamePage = namesPageRu[prevPageArray[prevPageArray.length - 2]];
          break;
      }
    },
  },
});

export const { setNamePage, increment, decrement, setActiveLangSl, cleanCount } = backHistorySlice.actions;

export const getPage = state => state.historyPage.pageName;
export const getCount = state => state.historyPage.count;
export const getCorectyName = state => state.historyPage.corectyNamePage;

export default backHistorySlice.reducer;
